import {
  useYoutubeUrlPlugin,
  YOUTUBE_URL_TAB_KEY,
} from '@sparemin/media-import';
import React from 'react';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import MediaImporterOverlay from '../MediaImporterOverlay';

export interface YouTubeMediaUploadModalContentsProps {}

const YouTubeMediaUploadModalContents: React.FC<YouTubeMediaUploadModalContentsProps> = () => {
  const { params, onHide } = useConnectedModal('YouTubeMediaUpload');

  const { uploadContext } = params || {};

  return (
    <MediaImporterOverlay
      {...{ uploadContext, onHide }}
      mediaImporterProps={{
        defaultSelectedTabKey: YOUTUBE_URL_TAB_KEY,
        plugins: [useYoutubeUrlPlugin()],
      }}
    />
  );
};

export default YouTubeMediaUploadModalContents;
